import Vue from 'vue'

Vue.filter('formatCentre', function(value) {
  if (value) {
    return value.map(c => c.Name).join(", ");
  }
})